import { CATEGORIES } from "@/constants/data";

/**
 * Step 4: read-only summary of everything the visitor entered, shown right before submit.
 */
const SummaryStep = ({ form }) => (
  <div className="flex flex-col gap-3 text-sm" data-testid="inquiry-summary">
    <div className="rounded-[12px] border border-[color:var(--line)] p-4 flex flex-col gap-2 bg-[color:hsl(var(--secondary))]/40">
      <p>
        <span className="text-[color:hsl(var(--muted-foreground))]">Ad Soyad:</span> {form.name}
      </p>
      <p>
        <span className="text-[color:hsl(var(--muted-foreground))]">Telefon:</span> {form.phone}
      </p>
      <p>
        <span className="text-[color:hsl(var(--muted-foreground))]">E-posta:</span> {form.email}
      </p>
      <p>
        <span className="text-[color:hsl(var(--muted-foreground))]">Mülk Türü:</span>{" "}
        {CATEGORIES.find((c) => c.value === form.property_type)?.label}
      </p>
    </div>
  </div>
);

export default SummaryStep;
